import BasicRecord from "./BasicRecord";
import { exists } from "./object";

type ClassDescription =
    (string | null | undefined)[] | string | BasicRecord<boolean | null | undefined> | undefined | null;

function classname(...classDescriptions: ClassDescription[]): string {
    const classnames = new Set<string>();

    classDescriptions.forEach(description => {
        if (!description) {
            // no-op;
        } else if (Array.isArray(description)) {
            description
                .filter(exists)
                .forEach(name => classnames.add(name));
        } else if (typeof description === "string") {
            classnames.add(description);
        } else if (typeof description === "object") {
            Object
                .keys(description)
                .filter(name => description[name] === true)
                .forEach(name => classnames.add(name));
        }
    });

    return Array.from(classnames).join(" ");
}

export default classname;
